import React, { useEffect } from "react";
import { Spin, Button } from "antd";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { isEmpty } from "lodash";

import ListContainer from "../../modules/group/containers/List";
import withPage from "./withPage";

import "./GroupsInvite.scss";

const GroupsInvitePage = ({ isFetching, doGroupAcceptInvite, history, detailCode, status }) => {
  const search = window.location.search;
  const query = queryString.parse(search);

  useEffect(() => {
    if ((status === "succeeded" && isEmpty(detailCode)) || status === "failed") {
      history.push("/");
    }
  }, [detailCode]);

  const handleReject = () => {
    history.push("/");
  };

  const handleAccept = () => {
    doGroupAcceptInvite(query.code);
  };

  return (
    <Spin spinning={isFetching}>
      <div className="GroupsInvitePage">
        <div className="Logo">
          <Link to="/">
            <img src="/logo.svg" alt="logo" />
          </Link>
        </div>
        <div className="Main">
          <b>
            {detailCode.userName} has invited you to join {detailCode.companyName} on Parcelizer.
          </b>
          <p>After accepting, you'll be able to see the details and statuses of all orders tagged to your account</p>
        </div>
        <div className="Actions">
          <Button className="Reject" type="primary" onClick={handleReject}>
            Reject <ReactSVG className="icon" src="/icons/close.svg" />
          </Button>
          <Button className="Accept" type="primary" onClick={handleAccept}>
            Accept <ReactSVG className="icon" src="/icons/check.svg" />
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default withPage(ListContainer(GroupsInvitePage));
